import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";

import ListTaskOperationSatiaScreen from "../ListTaskOperationSatiaScreen";
import store from "../../../../../redux/store/index";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashSatiaScreen.results.item_count,
    results: state.reducerListTaskOperationSatiaScreen.results,
    resultsAll: state.reducerListTaskOperationSatiaScreen.resultsAll,
    NoInternetDialog: state.reducerListTaskOperationSatiaScreen.NoInternetDialog,
    showLoading: state.reducerListTaskOperationSatiaScreen.showLoading,
    lazyload_end: state.reducerListTaskOperationSatiaScreen.lazyload_end,
    showRefresh: state.reducerListTaskOperationSatiaScreen.showRefresh,
    failed: state.reducerListTaskOperationSatiaScreen.failed,
    page: state.reducerListTaskOperationSatiaScreen.page,
    empty: state.reducerListTaskOperationSatiaScreen.empty,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,
    resultsSet: state.reducerListTaskOperationSatiaScreen.resultsSet,
    isLoadingSet: state.reducerListTaskOperationSatiaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListTaskOperationSatiaScreen.NoInternetDialogSet,
    ListFilter: state.reducerListTaskOperationSatiaScreen.ListFilter,
    id: state.reducerListTaskOperationSatiaScreen.id,


});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListFilter: (data) => dispatch(serviceActionListFilter(data)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id) => {
    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetListTaskOperationSatiaScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());
            //  dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListTaskOperationSatiaScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();

    formData.append('typeSort', params.typeSort);
    formData.append('typeOrder', params.typeOrder);
    formData.append('token', params.token);
    formData.append('page', params.page);
    //formData.append('page', params.page);
    formData.append('month', params.month);

    if (Tools.CheckValue(params.searchText))
        formData.append('searchText', params.searchText);
    formData.append('beginDate', params.beginDate ? params.beginDate : null);
    formData.append('endDate', params.endDate ? params.endDate : null);
    formData.append('listFilter', JSON.stringify(params.listFilter));
    if (params.type) {
        formData.append('type', params.type);
        formData.append('subjectId', params.id);
        formData.append('name', params.name);
    }


    //  formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

    // formData.append('type', params.type);
    // formData.append('listFilter',JSON.stringify(params.listFilter) );
    // formData.append('trackingCode', params.trackingCode);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };

    // axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetListTaskOperationSatiaScreen:


                    if (response.data.status) {

                        let result = response.data.result;
                        let data = result && result.data ? result.data : result;
                        if (data == null) data = []
                        // let arr = store.getState().reducerGalleryServiceOperationScreen.results
                        // if (page == 1) {
                        //     arr = data
                        //     global.list_menu_shahrdar=response.data.result.menu
                        // } else {
                        //     if (arr.length > 0)
                        //     //    arr.push(data);
                        //         arr = [...arr, ...data]
                        //     else
                        //         arr = data
                        // }

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee));
                        }

                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee)));
                        }


                    } else {

                        dispatch(serviceActionError(response, page))

                        //alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetListTaskOperationSatiaScreen:
                    if (response.data.status)
                        dispatch(serviceActionSuccessSet(response.data, id))
                    else
                        dispatch(serviceActionError("error", page))
                    //    alert(response.data.message)
                    break;
                default:
                    console.log("default")
            }
        }).catch((e) => {
        console.log("ahmad=> error", e)
        switch (type) {
            case typeExport.TypeGetListTaskOperationSatiaScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListTaskOperationSatiaScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        } else {
            switch (type) {
                case typeExport.TypeGetListTaskOperationSatiaScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetListTaskOperationSatiaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListTaskOperationSatiaScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListTaskOperationSatiaScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListTaskOperationSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (data, page, res) => ({

    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    resultsAll: res,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page) => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.ListTaskOperationSatiaScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})

export default connect(mapStateToProps, mapDispatchToProps)(ListTaskOperationSatiaScreen);
